import { ref } from "vue";
import {
  suggestContext,
  getSuggestContextErrorMessage,
  SUGGEST_CONTEXT_FALLBACK_ERROR,
} from "@/api";

export const ENTITY_CONTEXT_MAX_LENGTH = 5000;

/**
 * ER-10218: drives the ContextTab "Suggest" action for one org-object type.
 * The suggestion is held as an unsaved `draft` (fed to ContextTab) — it is never saved here.
 */
export function useContextSuggestion(objectType) {
  const draft = ref(null);
  const isSuggesting = ref(false);
  const suggestError = ref("");

  async function suggest(objectId) {
    if (!objectId || isSuggesting.value) return;
    isSuggesting.value = true;
    suggestError.value = "";
    try {
      const { data } = await suggestContext(objectType, objectId);
      const suggestion = typeof data?.suggestion === "string" ? data.suggestion.trim() : "";
      if (suggestion) {
        draft.value = suggestion;
      } else {
        suggestError.value = SUGGEST_CONTEXT_FALLBACK_ERROR;
      }
    } catch (error) {
      suggestError.value = getSuggestContextErrorMessage(error);
    } finally {
      isSuggesting.value = false;
    }
  }

  function setDraft(value) {
    draft.value = value;
  }

  function clearDraft() {
    draft.value = null;
    suggestError.value = "";
  }

  return { draft, isSuggesting, suggestError, suggest, setDraft, clearDraft };
}
